export const toggleAccordion = (
  index: number,
  selectedIndex: number,
  setSelectedIndex: (index: number) => void,
  ITERATOR: number,
) => {
  if (index > ITERATOR && index !== selectedIndex) {
    setSelectedIndex(index)
  } else if (index === selectedIndex) {
    setSelectedIndex(ITERATOR)
  }
}
